import React, { useEffect } from "react";
import DashboardCard from "../../shared/DashboardCard";
import {
  Grid,
  List,
  ListItem,
  ListItemText,
  makeStyles,
  Table,
  TableBody,
  TableContainer,
  Typography,
  useTheme,
} from "@material-ui/core";
import {
  showCartIcon,
  thumbDownAltIcon,
  flagOutlinedIcon,
  cardTravelIcon,
  receiptIcon,
  callMadeIcon,
} from "../../stateless/cardIcons";
import TableHeadDistribution from "../../stateless/headTables/TableHeadDistribution";
import styles from "../../../styles/global-styles";
import { DistributionService } from "../../../services/distribution.service";
import { UserService } from "../../../services/user.service";
import CategorySelect from "../../shared/selects/CategorySelect";
import { actions } from "../../../redux/actions/alert";
import { connect } from "react-redux";
import DistributionBodyDashboard from "../../shared/table/DistributionBodyDashboard";
import { AuthService } from "../../../services/auth.service";
import { Role } from "../../../_utils/roleEnum";
import UpdatePassword from "../modals/UpdatePassword";
import { headCellDistribution } from "../../stateless/headTables/HeadCellDistribution";

const useStyles = makeStyles((theme) => ({
  table: {
    width: 300,
  },
  subtitle: styles.subtitle,
  row: styles.rowHover,
}));

const MainDashboard = ({ detailAlert, addAlert }) => {
  const classes = useStyles();
  const theme = useTheme();

  const [distributionArray, setDistributionArray] = React.useState([]);
  const [usersBlocked, setUsersBlocked] = React.useState([]);
  const [currentUser, setCurrentUser] = React.useState({});

  const handleCategorySelected = (key, value) => {
    console.log("category", value);
  };

  useEffect(() => {
    addAlert({ showAlert: false });
    const currentUserValue = AuthService.currentUserValue;
    setCurrentUser(currentUserValue);

    async function fetchData() {
      try {
        const distribution = await DistributionService.getFirstDistributions();
        const users = await UserService.getUsersBlocked();
        setDistributionArray(distribution.data);
        setUsersBlocked(users.data);
      } catch (error) {
        console.log(error);
        addAlert({ showAlert: true });
        detailAlert({ severity: "error", message: error.msgs });
      }
    }
    fetchData();
  }, []);

  return (
    <Grid container direction="row" justify="space-evenly" alignItems="center">
      {(currentUser.roleId === Role.Admin ||
        currentUser.roleId === Role.ManagerAccesory ||
        currentUser.roleId === Role.ManagerMovile ||
        currentUser.roleId === Role.Seller) && (
        <>
          <Grid item xs={12} md={5} lg={6}>
            <div>
              <DashboardCard
                title="Stock bajo"
                select={
                  <CategorySelect
                    category={handleCategorySelected}
                    showAll={false}
                  />
                }
                url="dashboard/inventario/distribucion"
                icon={thumbDownAltIcon}
              >
                <Typography
                  variant="h6"
                  component="h5"
                  style={{ margin: 40 }}
                  className={classes.subtitle}
                >
                  Seleccionar una categoria
                </Typography>
              </DashboardCard>
            </div>
          </Grid>
        </>
      )}

      {currentUser.roleId === Role.Seller && (
        <>
          <Grid item xs={12} md={5} lg={6}>
            <div>
              <DashboardCard
                title="Garantías en proceso"
                // select={<CategorySelect category={handleCategorySelected} />}
                url="dashboard/inventario/garantias"
                icon={receiptIcon}
              >
                <Typography
                  variant="h6"
                  component="h5"
                  style={{ margin: 45 }}
                  className={classes.subtitle}
                >
                  No hay ninguna garantía en proceso
                </Typography>
              </DashboardCard>
            </div>
          </Grid>

          <Grid item xs={12} md={5} lg={6}>
            <div>
              <DashboardCard
                title="Top productos vendidos"
                // select={<CategorySelect category={handleCategorySelected} />}
                url="dashboard/inventario/sucursal"
                icon={callMadeIcon}
              >
                <Typography
                  variant="h6"
                  component="h5"
                  style={{ margin: 45 }}
                  className={classes.subtitle}
                >
                  No hay ninguna venta registrada
                </Typography>
              </DashboardCard>
            </div>
          </Grid>
        </>
      )}

      {currentUser.roleId === Role.Admin && (
        <>
          <Grid item xs={12} md={5} lg={6}>
            <div>
              <DashboardCard
                title="Últimas ventas"
                icon={showCartIcon}
              ></DashboardCard>
            </div>
          </Grid>
          <Grid item xs={12} md={5} lg={6}>
            <div>
              <DashboardCard
                title="Productos en distribución"
                subtitle="Ver más"
                icon={cardTravelIcon}
                url="dashboard/inventario/distribucion"
              >
                <Grid style={{ marginTop: -30 }}>
                  {!distributionArray.length && (
                    <Typography
                      variant="h6"
                      component="h4"
                      style={{ marginTop: 50 }}
                      className={classes.subtitle}
                    >
                      No se encontraron productos en distribución.
                    </Typography>
                  )}
                  {distributionArray.length > 0 && (
                    <TableContainer>
                      <Table
                        className={classes.table}
                        aria-label="customized table"
                      >
                        <TableHeadDistribution
                          isMovile={true}
                          isDashboard={true}
                          headCells={headCellDistribution}
                        ></TableHeadDistribution>
                        <TableBody>
                          <DistributionBodyDashboard
                            distributionArray={distributionArray}
                          />
                        </TableBody>
                      </Table>
                    </TableContainer>
                  )}
                </Grid>
              </DashboardCard>
            </div>
          </Grid>

          <Grid item xs={12} md={5} lg={6}>
            <div>
              <DashboardCard
                title="Usuarios bloqueados"
                subtitle="Ver más"
                icon={flagOutlinedIcon}
                url="dashboard/usuarios"
              >
                <Grid style={{ marginTop: theme.spacing(1) }}>
                  {usersBlocked.map((user, id) => {
                    return (
                      <List key={id}>
                        <ListItem>
                          <ListItemText
                            style={{ fontWeight: 500, fontSize: 14 }}
                          >
                            {user.name} | {user.email} |{" "}
                            {user.site?.name || "N/A"} |{" "}
                            {user.role?.name || "N/A"}
                          </ListItemText>
                        </ListItem>
                      </List>
                    );
                  })}
                  {!usersBlocked.length && (
                    <Typography
                      variant="h6"
                      component="h5"
                      style={{ margin: 50 }}
                      className={classes.subtitle}
                    >
                      No hay usuarios bloqueados.
                    </Typography>
                  )}
                </Grid>
              </DashboardCard>
            </div>
          </Grid>
        </>
      )}
      {Object.values(currentUser).length > 0 &&
        currentUser.roleId !== Role.Admin &&
        !currentUser.verified && (
          <UpdatePassword
            open={!currentUser.verified}
            currentUser={currentUser}
          />
        )}
    </Grid>
  );
};

const dispatch = {
  detailAlert: actions.detailAlert,
  addAlert: actions.addAlert,
};

export default connect(undefined, dispatch)(MainDashboard);
